import { Pipe, PipeTransform } from '@angular/core';
import { IMultiPrintDevice } from '@multiprint/abstract/multi-print-device';

@Pipe({
  name: 'multiPrintDeviceMaterialFilter'
})
export class MultiPrintDeviceMaterialFilterPipe implements PipeTransform {

  transform(value: IMultiPrintDevice[], materialId: number): IMultiPrintDevice[] {
    if (materialId === -9) {
      return value;
    }

    return value.filter(d => d.materials.some(m => m.id === materialId));
  }
}
